// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__rb2tj","colCheckbox":"styles_colCheckbox__3Nglx"};